import { apiService } from "@/_services";
import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { timeParse } from "d3";

/**
 * Fetches all index forecasts from the API.
 *
 * @param {object} _this - Context variables for managing data and loading state.
 */
export function getIndexForecast(_this) {
  // Set loading state
  Object.assign(_this.loading, { forecastIndexes: true });
  // Define API request parameters
  let params = {
    method: "GET",
    endpoint: "index_fcst",
    content_type: "application/json",
    query_params: {
      date: formatDate_YMD(new Date()), // Current date formatted as YMD
      format: "json"
    }
  };
  // Make API call
  apiService
    .getAll(params)
    .then(data => {
      parseData(data, _this);
    })
    .catch(function(error) {
      Object.assign(_this.loading, { forecastIndexes: false });
      console.error("Error fetching index forecasts:", error);
    });
}

/**
 * Processes the retrieved forecast data and updates the context.
 *
 * @param {Array} data - The API response data.
 * @param {object} _this - Context variables for storing processed data.
 */
function parseData(data, _this) {
  // Extract unique index names
  let indexList = [
    ...new Map(data.map(d => [d.name, { pk: d.pk, name: d.name }])).values()
  ];
  Object.assign(_this.data, { indexList });
  // Process forecast data
  Object.assign(_this.data, {
    forecastIndexes: data.map(d => ({
      update_date: timeParse("%Y-%m-%d")(d.update_date), // Parse update date
      date: timeParse("%Y-%m-%d")(d.objective_date), // Parse forecasted date
      pk: d.pk,
      name: d.name,
      institution: d.institution,
      mean: d.mean
    }))
  });
  // Map index PKs to names
  let indexByPk = Object.fromEntries(data.map(d => [d.pk, d.name]));
  Object.assign(_this.data, { indexByPk });
  // Update loading state
  Object.assign(_this.loading, { forecastIndexes: false });
}
